import { render } from "./Sentry.vue?vue&type=template&id=8675297c"
import script from "./Sentry.vue?vue&type=script&lang=js"
export * from "./Sentry.vue?vue&type=script&lang=js"
script.render = render

export default script